import React from 'react';
import classnames from 'classnames';

import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { INewsItem } from '../../models/INewsItem';
import { NewsItem } from '../newsItem/NewsItem';

export interface IProps {
    store: ManningOnlineStore;
    news: INewsItem[];
}
export interface IState {}

export class News extends React.Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    public render(){
        return <div className="news-root">
                    <div className="news-container">
                        { this.props.news.map((it, index) => 
                            <NewsItem newsItem={it} key={index + it.title} store={this.props.store}/>
                        )}
                    </div>
               </div>
    }
}